import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const kkStepsScrollAnim = () => {
  const steps = document.querySelectorAll(".step-item");
  const verticalLine = document.querySelector(".vertical-line");
  const activeDot = document.querySelector(".active-dot");

  if (verticalLine) {
    gsap.to(verticalLine, {
      scrollTrigger: {
        trigger: ".steps-inner",
        start: "top+=-40% top",
        end: "bottom bottom",
        scrub: 1,
      },
      height: "100%",
      ease: "none",
    });
  }

  if (activeDot) {
    // Set initial position at first step's center
    const firstStep = steps[0];

    if (firstStep) {
      const firstStepRect = firstStep.getBoundingClientRect();
      const stepsInnerRect = document.querySelector('.steps-inner').getBoundingClientRect();
      const firstStepCenter = ((firstStepRect.top + firstStepRect.height/2) - stepsInnerRect.top) / stepsInnerRect.height * 100;

      activeDot.style.top = `${firstStepCenter}%`;
      gsap.to(activeDot, {
        scrollTrigger: {
          trigger: ".steps-inner",
          start: "top top",
          end: "bottom bottom-=20%", // End 20% from bottom
          scrub: 1, // Increased scrub value for slower movement
          onUpdate: (self) => {
            // Calculate dot position based on steps
            const progress = self.progress;
            const totalSteps = steps.length;
            const stepHeight = (100 - firstStepCenter) / (totalSteps - 1);
            const currentStep = Math.floor(progress * (totalSteps - 1));
            const stepProgress = (progress * (totalSteps - 1)) % 1;
            const dotPosition = firstStepCenter + (currentStep * stepHeight) + (stepProgress * stepHeight);

            gsap.to(activeDot, {
                top: `${dotPosition}%`,
                duration: 0.3,
                ease: "power1.out"
            });
          }
        },
      });
   }
  }

   if (steps.length) {
      steps.forEach((step, index) => {
         const isOdd = index % 2 === 1;
         const content = step.querySelectorAll(
         ".text-content, .step-image, .year",
         );

         content.forEach((el) => {
         gsap.fromTo(
            el,
            {
               x: isOdd ? 100 : -100,
               opacity: 0,
            },
            {
               scrollTrigger: {
               trigger: step,
               start: "top 80%",
               end: "bottom 20%",
               toggleActions: "play reverse play reverse",
               },
               x: 0,
               opacity: 1,
               duration: 1,
               ease: "power2.out",
            },
         );
         });
      });
   }
};
